/** Die Kacheln einer Bereichsseite als einzelne Bausteine fuer den Katalog (BE-06). */
import { WissenAbschnitt } from '@/modules/wissen/components/WissenAbschnitt';
import { NotizenAbschnitt } from '@/modules/resources/components/NotizenAbschnitt';
import { useBereichDaten } from '@/modules/areas/board/bereichDaten';
import { BereichStatus } from '@/modules/areas/board/BereichStatus';
import { BereichAufgaben } from '@/modules/areas/board/BereichAufgaben';
import { BereichGewohnheiten } from '@/modules/areas/board/BereichGewohnheiten';
import { BereichDeadlines, BereichProjekte, BereichZiele } from '@/modules/areas/board/BereichVorhaben';
import { BereichTermine } from '@/modules/areas/board/BereichTermine';
import { BereichStatistik } from '@/modules/areas/board/BereichStatistik';
import { BereichListen } from '@/modules/listen/BereichListen';
import { BereichTraining } from '@/modules/training/BereichTraining';
import { BereichErnaehrung } from '@/modules/ernaehrung/BereichErnaehrung';

export function StatusKachel() { const { area, status, projects, goals } = useBereichDaten(); return <BereichStatus status={status} areaId={area.id} projects={projects} goals={goals} />; }
export function TrainingKachel() { const { area } = useBereichDaten(); return <BereichTraining areaId={area.id} immer={area.fest === 'gesundheit'} />; }
export function ErnaehrungKachel() { const { area } = useBereichDaten(); return <BereichErnaehrung areaId={area.id} immer={area.fest === 'gesundheit'} />; }
export function AufgabenKachel() { const { area, tasks } = useBereichDaten(); return <BereichAufgaben areaId={area.id} tasks={tasks} />; }
export function GewohnheitenKachel() { return <BereichGewohnheiten areaId={useBereichDaten().area.id} />; }
export function ZieleKachel() { const { area, goals, projects, tasks } = useBereichDaten(); return <BereichZiele area={area} goals={goals} projects={projects} tasks={tasks} />; }
export function ProjekteKachel() { const { area, projects, tasks } = useBereichDaten(); return <BereichProjekte area={area} projects={projects} tasks={tasks} />; }
export function DeadlinesKachel() { return <BereichDeadlines area={useBereichDaten().area} />; }
export function TermineKachel() { return <BereichTermine areaId={useBereichDaten().area.id} />; }
export function StatistikKachel() { const { area, tasks } = useBereichDaten(); return <BereichStatistik areaId={area.id} tasks={tasks} />; }
export function ListenKachel() { return <BereichListen areaId={useBereichDaten().area.id} />; }

export function WissenKachel() {
  const { area } = useBereichDaten();
  return (
    <section aria-label="Wissen" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-5 py-[18px]">
      <h2 className="text-[15px] font-bold">Wissen</h2>
      <WissenAbschnitt art="bereich" id={area.id} />
    </section>
  );
}

export function NotizenKachel() {
  const { area } = useBereichDaten();
  return (
    <section aria-label="Notizen & Gedanken" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-5 py-[18px]">
      <h2 className="text-[15px] font-bold">Notizen & Gedanken</h2>
      <NotizenAbschnitt art="bereich" id={area.id} />
    </section>
  );
}
